export const authErrorMessages = {
  invalidEmail: 'メールアドレスの形式が正しくありません。',
  invalidCredentials: 'メールアドレスまたはパスワードが間違っています。',
  tooManyRequests:
    '試行回数が多すぎます。しばらく待ってから再度お試しください。',
  loginFailed: 'ログインに失敗しました。',
  loginFailedCheckInput: 'ログインに失敗しました。入力内容をご確認ください。',
} as const

export const commonErrorMessages = {
  rootElementNotFound: 'ルート要素が見つかりません。',
} as const

export const sendErrorMessages = {
  limitSize: '写真は$sizeを超えてはなりません',
  limitFile: 'ファイル数は$number個までです',
  noContent: '送信するコンテンツがありません。',
  noMediaInput: 'メッセージまたはメディアを入力してください。',
  invalidFileFormat: 'ファイル形式がサポートされていません。${formats}ファイルを選択してください。',
  invalidUrl: 'URLの形式が正しくありません。',
  invalidMediaSize: '画像または動画のサイズを取得できませんでした。',
  invalidAssetSelection:
    '選択したメッセージ素材が見つかりません。素材を選び直してください。',
  scheduledDateTimeRequired: 'スケジュール日時を指定してください。',
  scheduledDateTimeInPast: 'スケジュール日時は現在時刻より後に設定してください。',
  recipientTagsRequired: '送信対象のタグを選択してください。',
  recipientUnavailable:
    'タグ管理機能が無効のため、この送信対象では送信できません。送信対象を選び直してください。',
  surveySelectionRequired: 'アンケートを選択してください。',
  settingsNotLoaded:
    '設定の読み込みが完了していません。画面を再読み込みしてください。',
} as const

export const posterFileErrorMessages = {
  failedToCreateBlob: 'Blobの生成に失敗しました',
  unsupportedVideoType: 'サポートされていない動画形式です',
  failedToGetCanvasContext: 'Canvasコンテキストの取得に失敗しました',
  failedToCreateEvent: 'イベントの生成に失敗しました',
} as const
